import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../nucleo/api';
import { CartaoIndicador } from '../../nucleo/ui/Estados';
import type { ModuloWeb } from '../../nucleo/modulos';
import { dicionario } from './i18n';
import { formatarDinheiro } from './tipos';

/**
 * F10: pedidos a receber (destaque), valor a receber e pedidos atrasados. ROB-01: o cartão é o CartaoIndicador do
 * núcleo (CONTRATOS 7.13): reticências só enquanto carrega; se a consulta falha, traço e "Tentar de novo" no cartão.
 */
function Indicadores() {
  const { t, i18n } = useTranslation('compras');
  const q = useQuery({ queryKey: ['compras', 'resumo'], queryFn: () => api<{ a_receber: number; valor_a_receber_centavos: string; atrasados: number }>('/api/v1/compras/resumo') });
  const destaque = (n: number) => <span className={n > 0 ? 'text-laranja' : undefined}>{n}</span>;
  return (
    <>
      <CartaoIndicador rotulo={t('indicadores.aReceber')} valor={q.data ? destaque(q.data.a_receber) : null} consultas={[q]} />
      <CartaoIndicador rotulo={t('indicadores.valor')} valor={q.data ? <span className="break-words">{formatarDinheiro(q.data.valor_a_receber_centavos, 'BRL', i18n.language)}</span> : null} consultas={[q]} />
      <CartaoIndicador rotulo={t('indicadores.atrasados')} valor={q.data ? destaque(q.data.atrasados) : null} consultas={[q]} />
    </>
  );
}

const carregar0 = () => import('./Requisicoes');
const carregar1 = () => import('./Cotacoes');
const carregar2 = () => import('./Pedidos');
const carregar3 = () => import('./Recebimentos');
const carregar4 = () => import('./Fornecedores');

const AcaoRequisicoes = acaoSobDemanda(carregar0, 'AcaoRequisicoes');
const FichaRequisicaoPagina = telaSobDemanda(carregar0, 'FichaRequisicaoPagina');
const ListaRequisicoes = telaSobDemanda(carregar0, 'ListaRequisicoes');
const AcaoCotacoes = acaoSobDemanda(carregar1, 'AcaoCotacoes');
const ListaCotacoes = telaSobDemanda(carregar1, 'ListaCotacoes');
const AcaoPedidos = acaoSobDemanda(carregar2, 'AcaoPedidos');
const FichaPedidoPagina = telaSobDemanda(carregar2, 'FichaPedidoPagina');
const ListaPedidos = telaSobDemanda(carregar2, 'ListaPedidos');
const FichaRecebimentoPagina = telaSobDemanda(carregar3, 'FichaRecebimentoPagina');
const ListaRecebimentos = telaSobDemanda(carregar3, 'ListaRecebimentos');
const ListaFornecedores = telaSobDemanda(carregar4, 'ListaFornecedores');

export const modulo: ModuloWeb = {
  slug: 'compras',
  menu: 'operacao',
  dicionario,
  abas: [
    { rotulo: 'abas.requisicoes', caminho: 'requisicoes', elemento: <ListaRequisicoes />, Acao: AcaoRequisicoes, ordem: 11 },
    { rotulo: 'abas.cotacoes', caminho: 'cotacoes', elemento: <ListaCotacoes />, Acao: AcaoCotacoes, ordem: 12 },
    { rotulo: 'abas.pedidos', caminho: 'pedidos', elemento: <ListaPedidos />, Acao: AcaoPedidos, ordem: 13 },
    { rotulo: 'abas.recebimentos', caminho: 'recebimentos', elemento: <ListaRecebimentos />, ordem: 14 },
    { rotulo: 'abas.fornecedores', caminho: 'fornecedores', elemento: <ListaFornecedores />, ordem: 15 },
  ],
  rotas: [
    { path: 'operacao/requisicao/:id', element: <FichaRequisicaoPagina /> },
    { path: 'operacao/pedido-compra/:id', element: <FichaPedidoPagina /> },
    { path: 'operacao/recebimento/:id', element: <FichaRecebimentoPagina /> },
  ],
  Indicadores,
};
